import { Nullable } from '@types'

import { POneEvent } from '@modules/auth/hooks/types'
import { AttendeeItem } from '@modules/profile/types'

export enum MeetingStatus {
  PENDING = 'PENDING',
  DECLINED = 'DECLINED',
  CANCELED = 'CANCELLED',
  PAST = 'PAST',
  UPCOMING = 'UPCOMING',
  NO_RESPONSE = 'NO_RESPONSE',

  /** P1+ internal status */
  INMAIL = 'INMAIL',

  /** Below two are temp statuses */
  SCHEDULED = 'SCHEDULED',
  RESCHEDULED = 'RESCHEDULED',
}

/** Temp logic to by pass BE issue for a while */
export const UPCOMING_MEETINGS = [MeetingStatus.UPCOMING, MeetingStatus.SCHEDULED, MeetingStatus.RESCHEDULED]

export type CompanyContactHistoryCounts = Record<MeetingStatus, number>

/** map by company ids */
export type CompanyContactsMap = Record<string, CompanyContactOverview>

export interface Meeting {
  id: number
  status: MeetingStatus
  event: POneEvent & { imported: boolean }
  attendees: { company: AttendeeItem[]; otherCompany: AttendeeItem[] }
  streamId: string
  date: string
  otherCompanyPrivate?: boolean
}

export type MeetingOverview = Pick<Meeting, 'id' | 'status' | 'date' | 'streamId'>

export interface CompanyContactOverview {
  counts: Nullable<CompanyContactHistoryCounts>
  recentMeeting: Nullable<Meeting>
}

export enum ActionType {
  ACTION_CREATE = 'Create',
  ACTION_CANCEL = 'Cancel',
  ACTION_UPDATE = 'Update',
  ACTION_LOCATION_UPDATE = 'Location update',
  ACTION_ACCEPT = 'Accept',
  ACTION_DELETE = 'Delete',
  ACTION_DECLINE = 'Decline',
  ACTION_REACTIVATE = 'Reactivate',
  ACTION_MISSING_AVAILABILITY = 'Missing availability',
  ACTION_SCHEDULE = 'Schedule',
  ACTION_RESCHEDULE = 'Reschedule',
  ACTION_RESCHEDULE_REQUEST = 'Rescheduling request',
}

export interface Person {
  id: number
  individualId: string
  title: string
  profilePicture: string
  firstName: string
  middleName: string
  lastName: string
  email: string
  createdAt: string
  updatedAt: string
  deletedAt: string
  companyName: string
  isHidden: boolean
}

export interface StreamMessageDto {
  id: number
  streamId: number
  subject: string
  body: string
  actionType: ActionType | null
  cancelType: string
  createdAt: string
  sender: Person
}

export interface StreamMessage {
  id: number
  authorId?: number
  author?: string
  authorInitials?: string
  date: string
  companyName?: string
  avatarSrc?: string
  messageText: string
  subject: string
  isMine: boolean
  isHidden: boolean
  isAdmin?: boolean
}

export interface StreamNotificationStatus {
  id: number
  status: string
  date: string
  authorId?: number
}

type MessageStreamItemTypeType<TItemType extends string, TItem> = {
  type: TItemType
  item: TItem
}

export type MessageStreamItem =
  | MessageStreamItemTypeType<'message', StreamMessage>
  | MessageStreamItemTypeType<'status', StreamNotificationStatus>

export interface FetchStreamMessagesResult {
  messages: StreamMessage[]
  notificationStatuses: StreamNotificationStatus[]
  hasMore: boolean
  total: number
  subject?: string
}
